module.exports = __webpack_public_path__ + "img/logo-big.441cd64e.png";